import {
  SEARCH_SAP_GET_DATA,
  STORE_CALL_VISIT_POST,
  STORE_CALL_VISIT_GET,
  STORE_CALL_VISIT_SEND_MAIL_POST,
  STORE_CALL_VISIT_GET_VENDOR_DATA,
} from "./Constants";

// GET SEARCH SAP
const loadSearchSAPGetDataRequest = (id) => ({
  type: SEARCH_SAP_GET_DATA.SEARCH_SAP_GET_DATA_LOAD,
  id,
});

const setSearchSAPGetDataSuccess = (searchsap) => ({
  type: SEARCH_SAP_GET_DATA.SEARCH_SAP_GET_DATA_SUCCESS,
  searchsap,
});

const setSearchSAPGetDataFail = (error) => ({
  type: SEARCH_SAP_GET_DATA.SEARCH_SAP_GET_DATA_FAIL,
  error,
});

// POST STORE VISIT
const loadStoreCallVisitPostRequest = (payload) => ({
  type: STORE_CALL_VISIT_POST.STORE_CALL_VISIT_POST_LOAD,
  payload,
});

const setStoreCallVisitPostSuccess = (data) => ({
  type: STORE_CALL_VISIT_POST.STORE_CALL_VISIT_POST_SUCCESS,
  data,
});

const setStoreCallVisitPostFail = (error) => ({
  type: STORE_CALL_VISIT_POST.STORE_CALL_VISIT_POST_FAIL,
  error,
});

// GET STORE VISIT LIST
// params: { status, event_date, store_location_id }
const loadStoreCallVisitGetRequest = (params) => ({
  type: STORE_CALL_VISIT_GET.STORE_CALL_VISIT_GET_LOAD,
  params,
});

const setStoreCallVisitGetSuccess = (storevisits) => ({
  type: STORE_CALL_VISIT_GET.STORE_CALL_VISIT_GET_SUCCESS,
  storevisits,
});

const setStoreCallVisitGetFail = (error) => ({
  type: STORE_CALL_VISIT_GET.STORE_CALL_VISIT_GET_FAIL,
  error,
});

// POST SEND MAIl
const loadStoreCallVisitSendMailPostRequest = (payload) => ({
  type: STORE_CALL_VISIT_SEND_MAIL_POST.STORE_CALL_VISIT_SEND_MAIL_POST_LOAD,
  payload,
});

const setStoreCallVisitSendMailPostSuccess = (data) => ({
  type: STORE_CALL_VISIT_SEND_MAIL_POST.STORE_CALL_VISIT_SEND_MAIL_POST_SUCCESS,
  data,
});

const setStoreCallVisitSendMailPostFail = (error) => ({
  type: STORE_CALL_VISIT_SEND_MAIL_POST.STORE_CALL_VISIT_SEND_MAIL_POST_FAIL,
  error,
});

//Get vendor data
const loadStoreCallVisitGetVendorDataRequest = (params) => ({
  type: STORE_CALL_VISIT_GET_VENDOR_DATA.STORE_CALL_VISIT_GET_VENDOR_DATA_LOAD,
  params,
});

const setStoreCallVisitGetVendorDataSuccess = (vendordata) => ({
  type: STORE_CALL_VISIT_GET_VENDOR_DATA.STORE_CALL_VISIT_GET_VENDOR_DATA_SUCCESS,
  vendordata,
});

const setStoreCallVisitGetVendorDataFail = (error) => ({
  type: STORE_CALL_VISIT_GET_VENDOR_DATA.STORE_CALL_VISIT_GET_VENDOR_DATA_FAIL,
  error,
});


export {
  loadSearchSAPGetDataRequest,
  setSearchSAPGetDataSuccess,
  setSearchSAPGetDataFail,
  loadStoreCallVisitPostRequest,
  setStoreCallVisitPostSuccess,
  setStoreCallVisitPostFail,
  loadStoreCallVisitGetRequest,
  setStoreCallVisitGetSuccess,
  setStoreCallVisitGetFail,
  loadStoreCallVisitSendMailPostRequest,
  setStoreCallVisitSendMailPostSuccess,
  setStoreCallVisitSendMailPostFail,
  loadStoreCallVisitGetVendorDataRequest,
  setStoreCallVisitGetVendorDataSuccess,
  setStoreCallVisitGetVendorDataFail,
};